import { Pipe, PipeTransform } from '@angular/core';
import { StepStatus } from 'src/app/components/steps/StepStatus';
@Pipe({
  name: 'step_status'
})
export class StatusPipe implements PipeTransform {

  transform(status: number) {
    if (status == StepStatus.incomplete) {
        return 'Incomplete'
    } else if (status == StepStatus.complete) {
        return 'Complete'
    } else if (status == StepStatus.pending) {
        return 'Pending'
    } else if (status == StepStatus.reopened) {
        return 'Re-opened'
    }
    else if (status == StepStatus.awaiting_client) {
        return 'Awaiting Client'
    }
     else if (status == StepStatus.client_hold) {
        return 'Client Intervention'
    } else if (status == StepStatus.paused) {
        return 'Paused'
    } else if (status == StepStatus.awaiting_missing_info) {
        return 'Awaiting Missing Info'
    }
    return status;
}
// if the final checkbox is checked ask if you want to complete the task


}
